<template>
    <div  class="all-height">
        <el-main class="all-height">
            <div class="operation-bar">
                <h1>消息列表</h1>
            </div>
            <div class="orderInfo-box">
                <el-table :data="messageList" height="calc(100% - 55px)"
                          :header-cell-style="{background:'#4885CA', color: 'white'}">
                    <el-table-column :show-overflow-tooltip='true' label="标题" header-align="center" align="center">
                        <template slot-scope="scope">
                            <el-button type="text" @click="viewContent(scope.$index, scope.row)">{{scope.row.msgTitle}}</el-button>
                        </template>
                    </el-table-column>
                    <el-table-column label="发布时间" header-align="center" align="center">
                        <template slot-scope="scope">
                            <span style="margin-left: 10px">{{ dateFormat(scope.row.createTime) }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="status" label="状态" header-align="center" align="center">
                        <template slot-scope="scope">
                            <el-tag effect="light" type="success" v-if="scope.row.status === '已读'">已读</el-tag>
                            <el-tag effect="light" type="danger" v-else>未读</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column label="查看" header-align="center" align="center">
                        <template slot-scope="scope">
                            <i class="el-icon-view" @click.stop="viewContent(scope.$index, scope.row)"></i>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </el-main>

        <el-dialog :title="msg_frmData.msgTitle" :visible.sync="dialogVisible" width="30%">
            <hr>
            <div style="height: 200px;overflow-y: scroll">
                <p>{{msg_frmData.msgContent}}</p>
            </div>
            <div style="margin-top: 20px;" v-show="msg_frmData.files && msg_frmData.files.length > 0">
                <p>附件：</p>
                <ul>
                    <li v-for="item in msg_frmData.files" :key="item.pkFileUpload"><el-button type="text" @click="downFile(item)">{{item.oldName}}</el-button></li>
                </ul>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">确 定</el-button>
              </span>
        </el-dialog>


    </div>
</template>

<script>
import {mapState} from 'vuex';
import dayjs from "dayjs";
export default {
    name: "message-management",
    data() {
        return {
            drawer: false,
            labelWidth: '60px',
            dialogVisible: false,
            receiverVisible: true,
            msg_frmTitle: '消息',
            msg_frmData: {}
        };
    },
    computed: {
        ...mapState('msg/messageManagement',['messageList'])
    },
    methods: {
        query() {
            this.$store.dispatch('msg/messageManagement/getMessageList');
        },
        viewContent(index, row) {
            this.msg_frmData.msgTitle = row.msgTitle;
            this.msg_frmData.msgContent = row.msgContent;
            this.msg_frmData.files = row.fileUploads;
            this.dialogVisible = true;
            if(row.status === '未读'){
                this.$store.dispatch('msg/messageManagement/readMessage',{currentUser: this.$store.state.login.currentUser, row: row}).then((ret) => {
                    if(ret.code === '200') {
                        row.status = '已读';
                    }else{
                        this.$message.error(ret.data?ret.data : ret.message);
                    }
                });
            }
        },
        downFile(item) {
            this.$store.dispatch('msg/messageManagement/download',{pkFileUpload: item.pkFileUpload});
        },
        dateFormat(val) {
            if (val) {
                return dayjs(val).format('YYYY-MM-DD HH:mm');
            } else {
                return '';
            }
        }
    },
    created() {
        this.query();
    }
}
</script>

<style scoped>
.orderInfo-box{
    position: relative;
    background-color: white;
    height: calc(100% - 35px);
    width: 100%;
}
.el-table .el-button{
    padding: 0;
}
.cell i {
    font-size: 20px;
    cursor: pointer;
}
.cell i:hover {
    color: #5ED1FD;
}
</style>
